// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-1c-jA","stepperGroup":"index-stepperGroup-1LRrV","step":"index-step-2v8mo","stepActive":"index-stepActive-3cLn1","tipSpan":"index-tipSpan-3-Igt","hidden":"index-hidden-3b0po","table":"index-table-12Pco","tableLable":"index-tableLable-3IGxC","tableInput":"index-tableInput-1TVZs","input":"index-input-3Dgn_","inputButton":"index-inputButton-22Ah-","spanColor":"index-spanColor-zD1ae","tableSubmit":"index-tableSubmit-1wMRr","complete":"index-complete-wGtMP","info":"index-info-2WiCz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/main/index.less
// module id = 1049
// module chunks = 1